@if (startupFailed()) {
	<app-startup-error />
} @else {
	<app-page-layout />
	<app-notifications />
	<app-health-status />
	<app-idle-session-modal />
}
